<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="所属广告平台" prop="advertPlatform">
          <el-input v-model="dataForm.advertPlatform" placeholder="所属广告平台"></el-input>
      </el-form-item>
          <el-form-item label="广告主账号" prop="advertiserId">
          <el-input v-model="dataForm.advertiserId" placeholder="广告主账号"></el-input>
      </el-form-item>
          <el-form-item label="流水类型" prop="transactionType">
          <el-input v-model="dataForm.transactionType" placeholder="流水类型"></el-input>
      </el-form-item>
          <el-form-item label="流水产生时间" prop="accountCreateTime">
          <el-input v-model="dataForm.accountCreateTime" placeholder="流水产生时间"></el-input>
      </el-form-item>
          <el-form-item label="交易总金额(单位元)" prop="amount">
          <el-input v-model="dataForm.amount" placeholder="交易总金额(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="冻结总金额(单位元)" prop="frozen">
          <el-input v-model="dataForm.frozen" placeholder="冻结总金额(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="现金总金额(单位元)" prop="cash">
          <el-input v-model="dataForm.cash" placeholder="现金总金额(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="赠款总金额(单位元)" prop="grant">
          <el-input v-model="dataForm.grantss" placeholder="赠款总金额(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="返货总金额(单位元)" prop="returnGoods">
          <el-input v-model="dataForm.returnGoods" placeholder="返货总金额(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="交易流水号" prop="transactionSeq">
          <el-input v-model="dataForm.transactionSeq" placeholder="交易流水号"></el-input>
      </el-form-item>
          <el-form-item label="付款方" prop="remitter">
          <el-input v-model="dataForm.remitter" placeholder="付款方"></el-input>
      </el-form-item>
          <el-form-item label="收款方" prop="payee">
          <el-input v-model="dataForm.payee" placeholder="收款方"></el-input>
      </el-form-item>
          <el-form-item label="返点" prop="dealbase">
          <el-input v-model="dataForm.dealbase" placeholder="返点"></el-input>
      </el-form-item>
          <el-form-item label="状态（开1、关0）" prop="status">
          <el-input v-model="dataForm.status" placeholder="状态（开1、关0）"></el-input>
      </el-form-item>
          <el-form-item label="创建人" prop="createdBy">
          <el-input v-model="dataForm.createdBy" placeholder="创建人"></el-input>
      </el-form-item>
          <el-form-item label="修改人" prop="updatedBy">
          <el-input v-model="dataForm.updatedBy" placeholder="修改人"></el-input>
      </el-form-item>
          <el-form-item label="创建时间" prop="createTime">
          <el-input v-model="dataForm.createTime" placeholder="创建时间"></el-input>
      </el-form-item>
          <el-form-item label="修改时间" prop="updateTime">
          <el-input v-model="dataForm.updateTime" placeholder="修改时间"></el-input>
      </el-form-item>
          <el-form-item label="删除时间" prop="deleteTime">
          <el-input v-model="dataForm.deleteTime" placeholder="删除时间"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        advertPlatform: '',
        advertiserId: '',
        transactionType: '',
        accountCreateTime: '',
        amount: '',
        frozen: '',
        cash: '',
        grantss: '',
        returnGoods: '',
        transactionSeq: '',
        remitter: '',
        payee: '',
        dealbase: '',
        status: '',
        createdBy: '',
        updatedBy: '',
        createTime: '',
        updateTime: '',
        deleteTime: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        advertPlatform: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        advertiserId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        transactionType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        accountCreateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        amount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        frozen: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        cash: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        grantss: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        returnGoods: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        transactionSeq: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        remitter: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        payee: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        dealbase: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createdBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updatedBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/rdaccountlog/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/rdaccountlog/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
